module.exports = __webpack_public_path__ + "static/zapier-integrations-mobile-ac5cd13b5a17ea5884c005c01b3205ac.png";